// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,

    // Configurações Aplicação:
   // amb_teste   serverUrl: 'https://tperioapi.checknpass.com.br/api/',
   // amb_teste   baseUrl: 'https://tperioapi.checknpass.com.br/',
    serverUrl: 'https://api.tpeni.app.br/api/',
    baseUrl: 'https://api.tpeni.app.br/api/',
//    clientUrl: 'http://localhost:4200/',
obterTokenUrl: 'publicador/auth',
esquecisenha: 'publicador/esquecisenha'

    // API's
    //urlSufApi: 'http://localhost:3000/'
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
